import React, { useId, useState } from 'react';
import { FileTextIcon, UploadCloudIcon, XIcon } from 'lucide-react';
type CvUploadProps = {
  fileName: string;
  error?: string;
  required?: boolean;
  onSelect: (file: File) => void;
  onClear: () => void;
};
export function CvUpload({
  fileName,
  error,
  required = true,
  onSelect,
  onClear
}: CvUploadProps) {
  const id = useId();
  const [dragging, setDragging] = useState(false);
  const onDrop = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file) onSelect(file);
  };
  return <div data-id="element-103" data-mp="1t5fo7aav14pn">
      <p className="mb-1.5 block text-sm font-medium text-ink" data-id="element-104" data-mp="1t6z24u91n3o9">
        CV / résumé
        {required ? <span className="text-gold-700" aria-hidden="true" data-id="element-105" data-mp="1p66s3ysckuqx">
            {' '}
            *
          </span> : <span className="font-normal text-muted" data-id="element-106" data-mp="3ni4aucyzm6ag"> (optional)</span>}
      </p>
      {fileName ? <div className="flex items-center justify-between gap-3 rounded-md border border-line bg-ivory px-4 py-3" data-id="element-107" data-mp="3jgsmearunr3u">
          <span className="flex min-w-0 items-center gap-2 text-sm text-ink" data-id="element-108" data-mp="3m3yk6i16jk6c">
            <FileTextIcon className="h-4 w-4 shrink-0 text-royal" aria-hidden="true" data-id="element-109" data-mp="3m1vk156bcanw" />
            <span className="truncate" data-id="element-110" data-mp="386jpoyw2km7i">{fileName}</span>
          </span>
          <button type="button" onClick={onClear} className="rounded p-1 text-muted transition-colors duration-150 hover:bg-white hover:text-ink" aria-label={`Remove ${fileName}`} data-id="element-111" data-mp="3c6tvobjv3cmd">
            <XIcon className="h-4 w-4" data-id="element-112" data-mp="8r68rifd1xq1" />
          </button>
        </div> : <>
          <input id={id} name="cv" type="file" accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" className="peer sr-only" aria-invalid={error ? true : undefined} aria-describedby={`${id}-desc`} onChange={e => {
        const file = e.target.files?.[0];
        if (file) onSelect(file);
        e.target.value = '';
      }} data-id="element-113" data-mp="3r1i68444d18u" />
          <label htmlFor={id} onDragOver={e => {
        e.preventDefault();
        setDragging(true);
      }} onDragLeave={() => setDragging(false)} onDrop={onDrop} className={`flex cursor-pointer flex-col items-center justify-center gap-2 rounded-md border border-dashed px-4 py-7 text-center transition-colors duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-gold ${dragging ? 'border-royal bg-royal-100' : error ? 'border-danger bg-danger-100/40' : 'border-line bg-ivory hover:border-royal'}`} data-id="element-114" data-mp="sac6566m63mp">
            <UploadCloudIcon className="h-6 w-6 text-royal" aria-hidden="true" data-id="element-115" data-mp="3vr2gfx98b2u7" />
            <span className="text-sm font-medium text-ink" data-id="element-116" data-mp="3qu28fgstjq0g">Choose a file or drag it here</span>
            <span className="text-xs text-muted" data-id="element-117" data-mp="3go10d4ghz21y">PDF or Word, up to 5 MB</span>
          </label>
        </>}
      <p id={`${id}-desc`} className={`mt-1.5 text-sm ${error ? 'text-danger' : 'text-xs text-muted'}`} data-id="element-118" data-mp="3lmcbrjmfxkma">
        {error ?? 'Files are checked in your browser. Secure upload and storage will be enabled once a backend is connected.'}
      </p>
    </div>;
}